// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe, enumOf } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isTokenUsage = objectOf({
  prompt_tokens: maybe(number, true),
  completion_tokens: maybe(number, true),
  total_tokens: maybe(number, true),
  cached_tokens: maybe(number, true),
  reasoning_tokens: maybe(number, true),
});

export const isToolExecutionLog = objectOf({
  name: string,
  arguments: maybe(string, true),
  duration: number,
});

export const isCallingObjectInformation = objectOf({
  object_type: maybe(string, true),
  name: maybe(string, true),
  user_id: maybe(string, true),
  item_id: maybe(string, true),
});

export const isRuleResolution = objectOf({
  ruleset_name: string,
  rule_index: number,
  resolution: enumOf("resolved", "ignored", "asked_operator"),
  resolved_at: maybe(number, true),
  resolved_by_developer_name: maybe(string, true),
  resolved_by_developer_email: maybe(string, true),
});

// Validates only the slim digest fields. objectOf is non-strict, so the fat fields the
// backend still serializes while agent_console_slim_logs_digest is off are ignored rather
// than rejected -- the digest consumers must not read them either way.
const isGenerativeAiAgentIdLogsResultItem = objectOf({
  invocation_id: string,
  start_time: number,
  duration: maybe(number, true),
  is_error: boolean,
  token_usage: maybe(isTokenUsage, true),
  calling_object_information: maybe(isCallingObjectInformation, true),
});

export const isGenerativeAiAgentIdLogsResult = objectOf({
  hits: number,
  hits_capped: maybe(boolean, true),
  results: arrayOf(isGenerativeAiAgentIdLogsResultItem),
});
